import styled from 'styled-components';

import { LastUpdated } from 'components/groupPayerNetworkStatuses/facilityNetworkStatusColumns';
import { AdminListPageConfig } from 'hooks/useAdminListPage';
import { NetworkStatusClientSummary } from 'models/GroupPayerNetworkStatus';
import {
  adminIndexNetworkStatusClients,
  groupPayerNetworkStatusQueryKeys,
} from 'services/api/groupPayerNetworkStatuses';
import PencilIconOutline from 'svg/PencilIconOutline';

import AddPayerNetworkStatusModal from './AddPayerNetworkStatusModal';

export const ADMIN_NETWORK_STATUS_PATH = '/admin/admissions/payer-network-status';

const clientPath = (clientId: string) => `${ADMIN_NETWORK_STATUS_PATH}/${clientId}`;

// Admin > AI > Admissions > Payer Network Status: the clients configured so far, like the other tabs'
// lists. Add starts a new one, and inbound referrals need not be on, so staff can set a client up before launch.
export const payerNetworkStatusClientsConfig: AdminListPageConfig<NetworkStatusClientSummary> = {
  title: 'Payer Network Status',
  columnStorageKey: 'admin.payerNetworkStatus',
  queryKey: groupPayerNetworkStatusQueryKeys.clients(),
  fetchFn: adminIndexNetworkStatusClients,
  fetchParams: { defaultSort: 'name asc' },
  searchPlaceholder: 'Search Clients',
  showResultCount: true,

  columns: [
    { id: 'name', header: 'Client Name', render: (row) => <BoldText>{row.name}</BoldText> },
    {
      id: 'updatedAt',
      header: 'Last Updated',
      render: (row) => <LastUpdated at={row.updatedAt} by={row.updatedByName} />,
    },
  ],

  addButton: {
    label: 'Add Payer Network Status',
    permission: 'adminGroupPayerNetworkStatusEdit',
    onClick: (ctx) => ctx.openModal('addClient', {}),
  },

  // Not gated on edit: a View Only Olio Admin opens the same page, read-only.
  rowActions: [
    {
      label: 'Edit Payer Network Status',
      icon: <PencilIconOutline width={18} height={18} />,
      onClick: (row, { navigate }) => navigate(clientPath(row.id)),
    },
  ],

  customModals: {
    addClient: {
      render: (_row, _show, onClose, ctx) => (
        <AddPayerNetworkStatusModal onClose={onClose} ctx={ctx} clientPath={clientPath} />
      ),
    },
  },
};

const BoldText = styled.span`
  font-weight: 500;
`;
